import {
  DefaultLinkModel,
} from '@projectstorm/react-diagrams';
import { Condition } from '../flow/types';
import { ConditionLabelModel } from '../labels/conditionLabel/ConditionLabelModel';

export class LinkModelData {
	condition?: Condition
}

export class LinkModel extends DefaultLinkModel {
	data: LinkModelData = {
	  condition: undefined,
	};

	constructor() {
	  super({
	    type: 'advanced',
	    width: 3,
	  });
	}

	addCondition(condition: Condition) {
	  this.data.condition = condition;
	  this.addLabel(new ConditionLabelModel({
	    label: `${condition.slot} ${condition.operator} ${condition.value}`,
	  }));
	}
}
